import React, { ReactNode } from 'react'
import ReactDOM from 'react-dom'
import Button from '../Buttons/Button'
import { ButtonSize } from '../Buttons/interfaces/size'
import { ModalProps } from './interfaces/ModalProps'

const Modal = ({children, isOpen, close, portalPath}: ModalProps) => {

  const rootDiv = document.getElementById(`${portalPath}`) as HTMLDivElement

  if (!rootDiv) {
    throw new Error(`Portal element with id '${portalPath}' not found`)
  }

  if (!isOpen) return null 
  
  return ReactDOM.createPortal(
    <div className="fixed top-0 left-0 w-full h-full bg-black/60 flex justify-center items-center z-[1000]">
      <div className="flex flex-col justify-between items-center bg-white py-4 px-5 rounded-md min-w-[45svw] min-h-[35svh]">
        <div className='w-full flex align-middle justify-center'>{children}</div>
        <div className='w-fit flex align-middle justify-center'>
          <Button size={ButtonSize.Small} color={`red`} callback={close}>Close</Button>
        </div>
      </div>
    </div>,
    document.getElementById(`${portalPath}`) as HTMLDivElement
  )
}

export default Modal